import { LPTSX5000 } from './LPTSX5000';
import { ETL_LS } from './ETL_LS';
import { QUINTECH_XTREME } from './QUINTECH_XTREME';

const switchTypes = {
  0: ETL_LS,
  1: LPTSX5000,
  3: QUINTECH_XTREME,
  4: LPTSX5000,
};

export function getSwitchType(type: 0 | 1 | 3 | 4): SwitchType {
  return switchTypes[type];
}

type SwitchType = {
  DEFAULT_PORT: string;
};
